import React from 'react';
import '../../../css/index.css';
import '../../../css/comingsoon.css'


const ComingSoon = () => {
  return (
    <div className="container--comingsoon">
      <div className='containernested--comingsoon--1'></div>
      <div className='containernested--comingsoon--2'><h1>Coming Soon. . .</h1></div>
      <div className='containernested--comingsoon--3'></div>
    </div>
  )
}
export default ComingSoon;
